export default __webpack_public_path__ + "static/quench-596c363c6dc2e0c0ab8a023b8756655a.png";